import { useState } from 'react';

import { AgButton, AgInput } from 'src/components/ui';

import type { FilterItemProps } from './filterItemTypes';

export default function TextFilter({ updateFilter, filter, column, onClose }: FilterItemProps) {
  const colName = column.headerName ?? column.field;
  const [value, setValue] = useState(() => {
    const val = filter.where?.[0]?.contains;
    return column.serverFilterValueTransform?.from?.(val) ?? val ?? '';
  });

  const submit = () => {
    const v = column.serverFilterValueTransform?.to?.(value) ?? value;
    updateFilter({ field: filter.field, where: [{ contains: v, mode: 'insensitive' }] });
    onClose?.();
  };

  return (
    <>
      <div className="p-2">
        <AgInput
          size="sm"
          aria-label={colName}
          value={value}
          onChange={(val) => setValue(val)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !!value) {
              submit();
            }
          }}
        />
      </div>
      <div className="flex justify-between gap-2 p-2 border-t border-neutral-5">
        <AgButton variant="destructive-white" onPress={() => updateFilter({ field: filter.field, where: [] })}>
          Clear
        </AgButton>
        <AgButton variant="primary" isDisabled={!value} onPress={submit}>
          Apply
        </AgButton>
      </div>
    </>
  );
}
